/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowDCornerLeftDownIcon24Solid = forwardRef('ArrowDCornerLeftDownIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M8 7.5A4.5 4.5 0 0 1 12.5 3h9a1.5 1.5 0 0 1 0 3h-9A1.5 1.5 0 0 0 11 7.5v10.129l4.19-4.19a1.5 1.5 0 0 1 2.12 2.122l-5.503 5.503a3.262 3.262 0 0 1-4.614 0l-5.504-5.503a1.5 1.5 0 0 1 2.122-2.122L8 17.63V7.5Z" })));
});
